






import { Component, Vue } from 'vue-property-decorator';
import { getAuthenticationClient } from '@/authentication/getAuthenticationClient';
@Component({})
export default class Sensitive extends Vue {
    async mounted() {
        const authenticationClient = await getAuthenticationClient();
        await authenticationClient.handleRedirectCallback()

        await this.$router.push({ name: 'Home'});
    }
}
